<template>
  <div>
    <container
      :isModal="true"
      @close-modal="closeScreen()"
      :loading="stateLoading || !stateReady"
    >
      <template v-slot:header>
        <h3 class="cadastro-licenca-titulo">Cadastro da Licença</h3>
      </template>
      <template v-slot:body>
        <template v-if="stateReady">
          <div
            class="licenca-bloqueio-aviso"
            role="status"
            v-if="motivoBloqueioEdicao"
          >
            <i class="pi pi-lock" aria-hidden="true"></i>
            <span>{{ motivoBloqueioEdicao }}</span>
          </div>
          <TabView :lazy="true" v-model:activeIndex="abaAtiva">
            <TabPanel header="Visualização" v-if="entity.idLicenca">
              <entity-selector-cliente
                :cliente="entity.cliente"
                :canEdit="false"
                :required="true"
                :parentLoading="stateBlocked"
              />

              <div class="p-col-12" style="height: 60vh">
                <iframe
                  :id="stateId + '_iframeVisualizacao'"
                  v-if="visualizacaoUrl?.url"
                  :src="visualizacaoUrl.url + '#view=fitH'"
                  frameborder="0"
                  marginwidth="0"
                  marginheight="0"
                  scrolling="no"
                  allowfullscreen
                  style="
                    border: 1px solid #ccc;
                    border-width: 1px;
                    width: 100%;
                    max-width: 100%;
                    height: 100%;
                  "
                />
                <Skeleton width="100%" height="100%" v-else />
              </div>

              <crud-licenca-orgao
                :parentLoading="stateLoading"
                :licenca="entity"
                labelNovo="Adicionar Órgão"
              >
                <template v-slot:acoesExtras>
                  <Button
                    label="Gerar Cópia"
                    class="p-button-rounded p-button-outlined"
                    v-if="amIAllowed('create', 'licenca')"
                    @click="gerarCopia()"
                  />
                </template>
              </crud-licenca-orgao>
            </TabPanel>
            <TabPanel :header="entity.idLicenca ? 'Edição' : 'Cadastrar'">
              <form :id="stateId + '_form'" @submit.prevent="submitSave">
                <entity-selector-cliente
                  :cliente="entity.cliente"
                  :canEdit="!entity.cliente?.idCliente && !stateBlocked"
                  @confirm-selection="confirmSelectionCliente"
                  :required="true"
                  :parentLoading="stateBlocked"
                />
                <fieldset :disabled="stateFullBlocked">
                  <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                      <DataTable
                        :value="[{ linha: 'Veículos' }, { linha: 'Rodízios' }]"
                        responsiveLayout="stack"
                      >
                        <Column
                          field="linha"
                          style="
                            width: 6rem;
                            justify-content: left;
                            vertical-align: top;
                            padding-top: 2rem;
                          "
                        />
                        <Column
                          v-for="(veiculo,
                          indexVeiculo) of entity.conjuntoTransportador"
                          :key="veiculo.nuSeqVeiculo"
                          style="vertical-align: top"
                        >
                          <template #header>
                            <div class="p-col-12 p-grid p-jc-end">
                              <template v-if="!veiculo.veiculoTrator">
                                <button-group
                                  v-if="true"
                                  :menuItems="
                                    true
                                      ? []
                                      : veiculosVisuals[indexVeiculo].menu
                                  "
                                  menuButtonClass="p-button-rounded p-button-info"
                                >
                                  <Button
                                    icon="fa-solid fa-arrow-left"
                                    v-title="
                                      'Mover Veículo Para Posição Anterior'
                                    "
                                    class="p-button-secondary p-button-rounded"
                                    @click="moveCarretaAntes(veiculo)"
                                    v-if="
                                      entity.conjuntoTransportador.length > 2 &&
                                        veiculo.nuSeqVeiculo > 1
                                    "
                                  />
                                  <Button
                                    icon="fa-solid fa-arrow-right"
                                    class="p-button-secondary p-button-rounded"
                                    v-title="
                                      'Mover Veículo Para Posição Posterior'
                                    "
                                    @click="moveCarretaDepois(veiculo)"
                                    v-if="
                                      entity.conjuntoTransportador.length > 2 &&
                                        veiculo.nuSeqVeiculo <
                                          entity.conjuntoTransportador.length -
                                            1 &&
                                        veiculo.nuSeqVeiculo > 0
                                    "
                                  />
                                  <Button
                                    icon="fas fa-trash-alt"
                                    v-title="'Remover Veículo da Composição'"
                                    class="p-button-rounded p-button-danger"
                                    @click="removeVeiculoConjunto(veiculo)"
                                  />
                                </button-group>
                              </template>
                            </div>
                          </template>
                          <template #body="slotProps">
                            <div class="p-col-12 p-p-0">
                              <template
                                v-if="slotProps.data.linha == 'Veículos'"
                              >
                                <entity-selector-veiculo-trator
                                  :cliente="entity.cliente"
                                  :required="true"
                                  :showLabel="false"
                                  :veiculoTrator="
                                    veiculo.veiculoTratorDaLicenca
                                  "
                                  v-if="veiculo.veiculoTrator"
                                  :focus="
                                    !veiculo.veiculoTrator?.idVeiculoTrator
                                  "
                                  @confirm-selection="
                                    confirmSelectionVeiculoTrator(
                                      veiculo,
                                      $event
                                    )
                                  "
                                  :blockedSelection="
                                    (veiculoTrator) =>
                                      blockedSelectionVeiculoTrator(
                                        veiculoTrator,
                                        veiculo.nuSeqVeiculo
                                      )
                                  "
                                  :label="
                                    veiculosVisuals[indexVeiculo]?.label
                                      ? veiculosVisuals[indexVeiculo].label
                                      : 'Veículo Trator'
                                  "
                                  :subLabel="
                                    veiculosVisuals[indexVeiculo]?.subLabel
                                      ? veiculosVisuals[indexVeiculo].subLabel
                                      : ''
                                  "
                                />
                                <template v-if="veiculo.carreta">
                                  <entity-selector-carreta
                                    :cliente="entity.cliente"
                                    :carreta="veiculo.carretaDaLicenca"
                                    :required="true"
                                    :showLabel="false"
                                    :focus="!veiculo.carreta?.idCarreta"
                                    :label="
                                      veiculosVisuals[indexVeiculo]?.label
                                        ? veiculosVisuals[indexVeiculo].label
                                        : veiculo.nuSeqVeiculo +
                                          'ª Carreta/Dolly'
                                    "
                                    :subLabel="
                                      veiculosVisuals[indexVeiculo]?.subLabel
                                        ? veiculosVisuals[indexVeiculo].subLabel
                                        : ''
                                    "
                                    @confirm-selection="
                                      confirmSelectionCarreta(veiculo, $event)
                                    "
                                    :blockedSelection="
                                      (carreta) =>
                                        blockedSelectionCarreta(
                                          carreta,
                                          veiculo.nuSeqVeiculo
                                        )
                                    "
                                  />
                                </template>
                              </template>
                              <template
                                v-if="slotProps.data.linha == 'Rodízios'"
                              >
                                <entity-selector-multi-carreta
                                  v-if="veiculo.carretaDaLicenca?.idCarreta"
                                  :cliente="entity.cliente"
                                  :carretas="
                                    veiculo.rodiziosAssociadosDaLicenca
                                  "
                                  :showLabel="false"
                                  :label="
                                    'Rod ' + veiculo.nuSeqVeiculo + 'ª Carreta'
                                  "
                                  :labelEmpty="'Selecione os Rodízios'"
                                  :required="false"
                                  @confirm-selection="
                                    confirmSelectionRodizios(veiculo, $event)
                                  "
                                  :blockedSelection="
                                    (carreta) =>
                                      blockedSelectionRodizio(
                                        carreta,
                                        veiculo.nuSeqVeiculo
                                      )
                                  "
                                >
                                  <template v-slot:extra-actions="slotProps">
                                    <Button
                                      class="p-button-sm"
                                      icon="fa-solid fa-arrow-up"
                                      @click="
                                        promoteRodizio(
                                          veiculo,
                                          slotProps.entity
                                        )
                                      "
                                      v-title="'Promover a principal'"
                                    />
                                  </template>
                                </entity-selector-multi-carreta>
                                <span v-else v-text="'---'" />
                              </template>
                            </div>
                          </template>
                        </Column>
                        <template #header>
                          <div class="p-grid p-jc-between">
                            <div
                              class="p-col-fixed p-as-center"
                              style="width: 15rem"
                            >
                              <label><b>Composição de Veículos</b></label>
                            </div>

                            <div class="p-col-fixed" style="width: 25rem">
                              <button-group>
                                <Button
                                  @click="addVeiculoTrator()"
                                  class="p-button-rounded"
                                  :label="'Adicionar Veículo Trator'"
                                  :disabled="
                                    entity.conjuntoTransportador?.length
                                  "
                                />
                                <Button
                                  :label="'Adicionar Carreta'"
                                  class="p-button-rounded"
                                  @click="addCarreta()"
                                  :disabled="
                                    !entity.conjuntoTransportador?.length ||
                                      entity.conjuntoTransportador?.length >
                                        maxVeiculos
                                  "
                                />
                              </button-group>
                            </div>
                          </div>
                        </template>
                        <template #footer v-if="possuiCarreta">
                          <div class="p-grid p-jc-end">
                            <div
                              class="p-col-fixed p-as-center"
                              style="width: 15rem"
                            >
                              <label
                                ><b
                                  >Total Unidades Acopladas:
                                  {{ totalAcopladas }}</b
                                ></label
                              >
                            </div>
                          </div>
                        </template>
                      </DataTable>
                    </div>
                    <div
                      class="p-field p-fluid p-col-12"
                      style="min-width: 35rem"
                    >
                      <entity-selector-gabarito
                        :idGabarito="entity.idGabarito"
                        :gabaritosDisponiveis="gabaritosFiltrados"
                        @after-set-gabarito="afterSetGabarito"
                        :readOnly="stateFullBlocked"
                        :required="true"
                        v-if="gabaritosFiltrados && gabaritosFiltrados.length"
                      />
                      <span
                        v-else-if="possuiVeiculoVazio"
                        v-text="
                          'Finalize a seleção dos veículos para selecionar o Gabarito'
                        "
                      />
                      <span
                        v-else
                        v-text="
                          'Não há gabarito válido encontrado para a composicao (' +
                            veiculosVisuals.map((e) => e.full).join(') + (') +
                            '). Verifique se veiculos principais estão na ordem correta (seguindo a ordem exata de como estarão acoplados).'
                        "
                      />
                    </div>

                    <template v-if="gabaritoSelecionado && !possuiVeiculoVazio">
                      <div class="p-field p-fluid p-col-12 p-md-12 p-xl-6">
                        <entity-selector-transportador
                          :transportador="entity.transportador"
                          @confirm-selection="confirmSelectionTransportador"
                          :required="true"
                          :cliente="entity.cliente"
                          :idTransportadorFiltered="
                            entity.transportador.idTransportador
                          "
                          :canEdit="
                            entity.transportador?.idTransportador &&
                              amIAllowed('edit', entity.transportador)
                          "
                        />
                      </div>

                      <div class="p-field p-fluid p-col-12 p-md-12 p-xl-6">
                        <entity-selector-engenheiro
                          :engenheiro="entity.engenheiro"
                          :cliente="entity.cliente"
                          :required="true"
                          :idEngenheiroFiltered="entity.engenheiro.idEngenheiro"
                          @confirm-selection="confirmSelectionEngenheiro"
                          :canEdit="
                            entity.engenheiro?.idEngenheiro &&
                              amIAllowed('edit', entity.engenheiro)
                          "
                        />
                      </div>
                      <template v-if="possuiCarga">
                        <div class="p-field p-fluid p-col-12 p-md-12 p-xl-6">
                          <input-with-label
                            label="Tipo de Carga"
                            :required="true"
                            v-slot="l"
                          >
                            <InputText
                              v-model="entity.tipoCarga"
                              :id="l.id"
                              :required="l.required"
                              v-title.bottom.focus="
                                'Verifique se o tipo de carroceria das carretas estão de acordo'
                              "
                            />
                          </input-with-label>
                        </div>

                        <div class="p-field p-fluid p-col-12 p-md-12 p-xl-6">
                          <input-file
                            label="Nota Fiscal Carga"
                            downloadTitle="Baixar Nota Fiscal Carga"
                            :id="stateId + '_notaFiscalCarga'"
                            :hasDownload="
                              !!(
                                entity.notaFiscalCarga &&
                                entity.notaFiscalCarga.keyBlDocumento
                              )
                            "
                            @click-download="downloadNotaFiscalCarga"
                            accept="image/jpeg, image/png, application/pdf"
                          />
                        </div>
                      </template>
                      <div
                        class="p-field p-fluid p-col-12 p-md-4"
                        :class="
                          gabaritoSelecionado.temExcessoLateral ||
                          gabaritoSelecionado.temExcessoLongitudinal
                            ? 'p-lg-2'
                            : ''
                        "
                      >
                        <input-with-label
                          label="Altura Total"
                          :required="true"
                          :subLabel="
                            'max ' +
                              formatNumber(gabaritoSelecionado.altura, {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 2
                              }) +
                              'm'
                          "
                          v-slot="l"
                        >
                          <InputNumber
                            v-model="entity.alturaTotal"
                            :min="2"
                            :max="gabaritoSelecionado.altura"
                            :step="0.01"
                            :minFractionDigits="2"
                            :maxFractionDigits="2"
                            :id="l.id"
                            :required="l.required"
                          />
                        </input-with-label>
                      </div>

                      <div
                        class="p-field p-fluid p-col-12 p-md-4"
                        :class="
                          gabaritoSelecionado.temExcessoLateral ||
                          gabaritoSelecionado.temExcessoLongitudinal
                            ? 'p-lg-2'
                            : ''
                        "
                      >
                        <input-with-label
                          label="Largura Total"
                          :required="true"
                          :subLabel="
                            'max ' +
                              formatNumber(gabaritoSelecionado.largura, {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 2
                              }) +
                              'm'
                          "
                          v-slot="l"
                        >
                          <InputNumber
                            v-model="entity.larguraTotal"
                            :min="2"
                            :max="gabaritoSelecionado.largura"
                            :step="0.01"
                            :minFractionDigits="2"
                            :maxFractionDigits="2"
                            :id="l.id"
                            :required="l.required"
                          />
                        </input-with-label>
                      </div>

                      <div
                        class="p-field p-fluid p-col-12 p-md-4"
                        :class="
                          gabaritoSelecionado.temExcessoLateral ||
                          gabaritoSelecionado.temExcessoLongitudinal
                            ? 'p-lg-2'
                            : ''
                        "
                      >
                        <input-with-label
                          label="Comprimento Total"
                          :required="true"
                          :subLabel="
                            'min ' +
                              formatNumber(gabaritoSelecionado.comprimentoMin, {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 2
                              }) +
                              'm, max ' +
                              formatNumber(gabaritoSelecionado.comprimentoMax, {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 2
                              }) +
                              'm'
                          "
                          v-slot="l"
                        >
                          <InputNumber
                            v-model="entity.comprimentoTotal"
                            :mix="gabaritoSelecionado.comprimentoMin"
                            :max="gabaritoSelecionado.comprimentoMax"
                            :step="0.01"
                            :minFractionDigits="2"
                            :maxFractionDigits="2"
                            :id="l.id"
                            :required="l.required"
                          />
                        </input-with-label>
                      </div>

                      <div
                        class="p-field p-fluid p-col-12 p-lg-6"
                        v-if="
                          gabaritoSelecionado.temExcessoLateral ||
                            gabaritoSelecionado.temExcessoLongitudinal
                        "
                      >
                        <div class="p-grid p-mt-1">
                          <div
                            v-if="gabaritoSelecionado.temExcessoLateral"
                            class="p-field p-fluid p-col-12 p-md-6"
                            :class="
                              gabaritoSelecionado.temExcessoLongitudinal
                                ? 'p-lg-3'
                                : ''
                            "
                          >
                            <input-with-label
                              label="Excesso Lateral Direito"
                              :required="true"
                              v-slot="l"
                            >
                              <InputNumber
                                v-model="entity.excessoLateralDireito"
                                :min="0"
                                :max="10"
                                :step="0.01"
                                :minFractionDigits="2"
                                :maxFractionDigits="2"
                                :id="l.id"
                                :required="l.required"
                              />
                            </input-with-label>
                          </div>

                          <div
                            v-if="gabaritoSelecionado.temExcessoLateral"
                            class="p-field p-fluid p-col-12 p-md-6"
                            :class="
                              gabaritoSelecionado.temExcessoLongitudinal
                                ? 'p-lg-3'
                                : ''
                            "
                          >
                            <input-with-label
                              label="Excesso Lateral Esquerdo"
                              :required="true"
                              v-slot="l"
                            >
                              <InputNumber
                                v-model="entity.excessoLateralEsquerdo"
                                :min="0"
                                :max="10"
                                :step="0.01"
                                :minFractionDigits="2"
                                :maxFractionDigits="2"
                                :id="l.id"
                                :required="l.required"
                              />
                            </input-with-label>
                          </div>

                          <div
                            v-if="gabaritoSelecionado.temExcessoLongitudinal"
                            class="p-field p-fluid p-col-12 p-md-6"
                            :class="
                              gabaritoSelecionado.temExcessoLateral
                                ? 'p-lg-3'
                                : ''
                            "
                          >
                            <input-with-label
                              label="Excesso Dianteiro"
                              :required="true"
                              v-slot="l"
                            >
                              <InputNumber
                                v-model="entity.excessoDianteiro"
                                :min="0"
                                :max="3"
                                :step="0.01"
                                :minFractionDigits="2"
                                :maxFractionDigits="2"
                                :id="l.id"
                                :required="l.required"
                              />
                            </input-with-label>
                          </div>

                          <div
                            v-if="gabaritoSelecionado.temExcessoLongitudinal"
                            class="p-field p-fluid p-col-12 p-md-6"
                            :class="
                              gabaritoSelecionado.temExcessoLateral
                                ? 'p-lg-3'
                                : ''
                            "
                          >
                            <input-with-label
                              label="Excesso Traseiro"
                              :required="true"
                              v-slot="l"
                            >
                              <InputNumber
                                v-model="entity.excessoTraseiro"
                                :min="0"
                                :max="3"
                                :step="0.01"
                                :minFractionDigits="2"
                                :maxFractionDigits="2"
                                :id="l.id"
                                :required="l.required"
                              />
                            </input-with-label>
                          </div>
                        </div>
                      </div>
                      <div class="p-field p-col-12 p-pt-5">
                        <DataTable
                          :value="[
                            { linha: 'roda', label: 'Rodas' },
                            {
                              linha: 'distancia',
                              label: 'Distâncias Entre Eixos'
                            },
                            { linha: 'peso', label: 'Peso dos Conjuntos' }
                          ]"
                          responsiveLayout="stack"
                        >
                          <template #header>
                            <div class="p-grid p-jc-start">
                              <div
                                class="p-col-fixed p-as-center"
                                style="width: 100%"
                              >
                                <label><b>Composição dos Eixos</b></label>
                              </div>
                            </div>
                          </template>
                          <ColumnGroup type="header">
                            <Row>
                              <Column
                                header="Imagem"
                                :colspan="1"
                                style="width: 12rem; justify-content: left"
                              />
                              <Column header="" :colspan="1">
                                <template #header>
                                  <div
                                    class="p-d-flex p-jc-center"
                                    style="width: 100%"
                                  >
                                    <img
                                      class="img-fluid"
                                      style="width: 100%"
                                      v-if="gabaritoUrl?.url"
                                      :src="gabaritoUrl.url"
                                      alt="Gabarito"
                                      @load="onloadGabaritoImage"
                                    />
                                    <Skeleton
                                      width="100%"
                                      height="20rem"
                                      v-else
                                    />
                                  </div>
                                </template>
                              </Column>
                            </Row>
                          </ColumnGroup>
                          <Column field="label" style="justify-content: left" />
                          <Column>
                            <template #header>
                              <div />
                            </template>
                            <template #body="slotProps">
                              <div
                                class="p-grid p-m-0 dynamic-grid-row"
                                style="position: relative"
                              >
                                <div class="p-col" style="height: 3rem" />
                                <template
                                  v-for="(veiculo,
                                  indexVeiculo) of entity.conjuntoTransportador"
                                  :key="veiculo.nuSeqVeiculo"
                                >
                                  <template
                                    v-for="(conjunto,
                                    indexConjunto) of veiculo.conjuntosEixosVeiculo"
                                    :key="conjunto.nuSeqVeiculo"
                                  >
                                    <template
                                      v-if="slotProps.data.linha == 'peso'"
                                    >
                                      <div
                                        class="p-col-fixed p-p-0"
                                        style="width: 4.5rem"
                                        :style="
                                          getPositionReferenteImagem(
                                            conjunto.eixos[0]?.positionImage,
                                            conjunto.eixos[
                                              conjunto.eixos.length - 1
                                            ]?.positionImage
                                          )
                                        "
                                      >
                                        <input-with-label
                                          subLabel="t"
                                          :forceSublabelUnder="true"
                                          v-slot="l"
                                          :required="true"
                                        >
                                          <InputNumber
                                            v-model="conjunto.pesoConjuntoEixos"
                                            :min="0.01"
                                            :max="
                                              conjunto.pesoMaximoConjuntoEixos ||
                                                50
                                            "
                                            :step="0.01"
                                            :minFractionDigits="2"
                                            :maxFractionDigits="2"
                                            :id="l.id"
                                            :required="l.required"
                                          />
                                        </input-with-label>
                                      </div>
                                    </template>
                                    <template
                                      v-else
                                      v-for="(eixo,
                                      indexEixo) of conjunto.eixos"
                                      :key="eixo.identificador"
                                    >
                                      <template
                                        v-if="slotProps.data.linha == 'roda'"
                                      >
                                        <div
                                          class="p-col-fixed p-p-0"
                                          style="width: 2.5rem"
                                          :style="
                                            getPositionReferenteImagem(
                                              eixo.positionImage,
                                              eixo.positionImage
                                            )
                                          "
                                        >
                                          <input-with-label
                                            v-slot="l"
                                            :required="true"
                                          >
                                            <InputNumber
                                              v-model="eixo.rodas"
                                              :min="2"
                                              :max="4"
                                              :step="2"
                                              :id="l.id"
                                              :required="l.required"
                                            />
                                          </input-with-label>
                                        </div>
                                      </template>
                                      <template
                                        v-else-if="
                                          slotProps.data.linha == 'distancia'
                                        "
                                      >
                                        <div
                                          class="p-col-fixed p-p-0"
                                          :style="
                                            'width: 3.9rem;' +
                                              getPositionReferenteImagem(
                                                conjunto.eixos[indexEixo - 1]
                                                  .positionImage,
                                                conjunto.eixos[indexEixo]
                                                  .positionImage
                                              )
                                          "
                                          v-if="indexEixo > 0"
                                        >
                                          <input-with-label
                                            subLabel="m"
                                            :forceSublabelUnder="true"
                                            v-title="
                                              'Distância entre o centro do eixo anterior e o eixo atual'
                                            "
                                            v-slot="l"
                                            :required="true"
                                          >
                                            <InputNumber
                                              v-model="
                                                eixo.distanciaEixoAnterior
                                              "
                                              :min="0.01"
                                              :max="
                                                gabaritoPermitidoSelecionado?.dinamico ||
                                                (indexVeiculo == 0 &&
                                                  indexConjunto == 0 &&
                                                  veiculo.bidirecional)
                                                  ? 20
                                                  : maxDistanciaEixoTandem
                                              "
                                              :minFractionDigits="2"
                                              :maxFractionDigits="2"
                                              :id="l.id"
                                              :required="l.required"
                                            />
                                          </input-with-label>
                                        </div>
                                        <div
                                          class="p-col-fixed p-p-0"
                                          :style="
                                            'width: ' +
                                              (indexVeiculo == 0 &&
                                              indexConjunto == 0
                                                ? 3.9
                                                : 5) +
                                              'rem;' +
                                              getPositionReferenteImagem(
                                                indexConjunto > 0
                                                  ? veiculo.conjuntosEixosVeiculo[
                                                      indexConjunto - 1
                                                    ].eixos.slice(-1)[0]
                                                      .positionImage
                                                  : indexVeiculo > 0
                                                  ? entity.conjuntoTransportador[
                                                      indexVeiculo - 1
                                                    ].conjuntosEixosVeiculo
                                                      .slice(-1)[0]
                                                      .eixos.slice(-1)[0]
                                                      .positionImage
                                                  : { x: 1 },
                                                indexVeiculo == 0 &&
                                                  indexConjunto == 0
                                                  ? {
                                                      x:
                                                        conjunto.eixos[
                                                          indexEixo
                                                        ].positionImage.x
                                                    }
                                                  : conjunto.eixos[indexEixo]
                                                      .positionImage
                                              )
                                          "
                                          v-else
                                        >
                                          <input-with-label
                                            :label="
                                              indexConjunto == 0 &&
                                              indexVeiculo == 0
                                                ? 'BD'
                                                : ''
                                            "
                                            :forceSublabelUnder="true"
                                            :subLabel="'m'"
                                            v-title="
                                              indexConjunto == 0
                                                ? indexVeiculo == 0
                                                  ? 'Distância entre a ponta do Para-choque dianteiro e o centro do primeiro eixo do veículo'
                                                  : 'Distância entre o centro do último eixo do veículo anterior e o centro primeiro eixo desde veículo'
                                                : 'Distância entre o centro último eixo do conjunto de eixos anterior e o centro do primeiro eixo do conjunto atual, do mesmo veículo'
                                            "
                                            v-slot="l"
                                            :required="true"
                                          >
                                            <InputNumber
                                              v-model="
                                                conjunto.distanciaConjuntoEixoAnterior
                                              "
                                              :min="0.01"
                                              :max="20"
                                              :step="0.01"
                                              :minFractionDigits="2"
                                              :maxFractionDigits="2"
                                              :id="l.id"
                                              :required="l.required"
                                            />
                                          </input-with-label>
                                        </div>
                                      </template>
                                    </template>
                                  </template>
                                </template>
                              </div>
                            </template>
                          </Column>

                          <template #footer>
                            <div class="p-grid p-mt-1 p-jc-end">
                              <div
                                class="p-field p-fluid p-col-fixed"
                                style="width: 10.5rem; margin-right: 0.75rem"
                              >
                                <input-with-label
                                  label="Peso bruto total"
                                  :required="true"
                                  :subLabel="
                                    gabaritoSelecionado
                                      ? 'max ' +
                                        formatNumber(gabaritoSelecionado.peso, {
                                          minimumFractionDigits: 1,
                                          maximumFractionDigits: 2
                                        }) +
                                        't'
                                      : ''
                                  "
                                >
                                  <template v-slot:default="l">
                                    <InputNumber
                                      v-model="pesoSomadoEixos"
                                      :max="
                                        gabaritoSelecionado
                                          ? gabaritoSelecionado.peso
                                          : 100
                                      "
                                      :step="0.01"
                                      :minFractionDigits="2"
                                      :maxFractionDigits="2"
                                      :id="l.id"
                                      :required="l.required"
                                      :disabled="true"
                                    />
                                  </template>
                                  <template v-slot:complement="l">
                                    <input
                                      type="number"
                                      v-model="pesoSomadoEixos"
                                      :max="
                                        gabaritoSelecionado
                                          ? gabaritoSelecionado.peso
                                          : 100
                                      "
                                      :required="l.required"
                                      :step="0.01"
                                      tabindex="-1"
                                      class="hidden-input"
                                    />
                                  </template>
                                </input-with-label>
                              </div>
                              <div
                                class="p-field p-fluid p-col-fixed"
                                style="width: 10.5rem; margin-right: 0.75rem"
                              >
                                <input-with-label
                                  label="Carga líquida"
                                  :subLabel="cargaLiquidaDescricao"
                                >
                                  <template v-slot:default="l">
                                    <InputNumber
                                      :modelValue="cargaLiquida"
                                      :minFractionDigits="2"
                                      :maxFractionDigits="2"
                                      :id="l.id"
                                      :disabled="true"
                                      placeholder="—"
                                      suffix=" t"
                                    />
                                  </template>
                                </input-with-label>
                              </div>
                              <div
                                class="p-field p-fluid p-col-fixed"
                                style="width: 16rem; margin-right: 17rem"
                              >
                                <input-with-label
                                  label="Balanço Traseiro"
                                  :required="true"
                                  :subLabel="
                                    'max ' +
                                      formatNumber(balancoTraseiroMax, {
                                        minimumFractionDigits: 1,
                                        maximumFractionDigits: 2
                                      }) +
                                      'm'
                                  "
                                >
                                  <template v-slot:default="l">
                                    <InputNumber
                                      v-model="balancoTraseiro"
                                      :max="balancoTraseiroMax"
                                      :step="0.01"
                                      :minFractionDigits="2"
                                      :maxFractionDigits="2"
                                      :id="l.id"
                                      :required="l.required"
                                      :disabled="true"
                                    />
                                  </template>
                                  <template v-slot:complement="l">
                                    <input
                                      type="number"
                                      v-model="balancoTraseiro"
                                      :max="balancoTraseiroMax"
                                      :step="0.01"
                                      :required="l.required"
                                      tabindex="-1"
                                      class="hidden-input"
                                    />
                                  </template>
                                </input-with-label>
                              </div>
                            </div>
                          </template>
                        </DataTable>
                      </div>
                    </template>
                    <div class="p-col-12" v-if="entity.idLicenca"></div>
                  </div>
                </fieldset>
              </form>
            </TabPanel>
            <TabPanel
              header="Histórico"
              v-if="
                entity.idLicenca &&
                  amIAllowed('view_historico', entity.permissionInfo)
              "
            >
              <historico-licenca
                :idLicenca="entity.idLicenca"
                :parentLoading="stateLoading"
              />
            </TabPanel>
          </TabView>
        </template>
      </template>
      <!-- rodape fixo do modal (fora da rolagem): botoes sempre visiveis; o atributo form liga
           o Salvar ao formulario da aba Edicao, que so existe enquanto ela esta aberta. Na
           Visualizacao os botoes ficam na barra dos orgaos (Adicionar Orgao e Gerar Copia); o Historico
           nao tem botoes -->
      <template v-slot:footer v-if="stateReady && isAbaEdicao">
        <div class="licenca-rodape-acoes">
          <Button
            type="submit"
            :form="stateId + '_form'"
            label="Salvar"
            class="p-button-rounded"
            :disabled="
              stateFullBlocked || possuiVeiculoVazio || !entity.idGabarito
            "
          />
          <Button
            label="Gerar Cópia"
            class="p-button-rounded p-button-outlined"
            v-if="entity.idLicenca && amIAllowed('create', 'licenca')"
            @click="gerarCopia()"
          />
        </div>
      </template>
    </container>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  onUnmounted,
  computed,
  watch,
  Ref,
  PropType
} from "vue";
import { useAuth, PermissionPayload } from "../../modules/auth";
import { useStorage } from "../../modules/storage";
import {
  round,
  copyObject,
  clearObject,
  cloneObject,
  formatNumber,
  waitUntilStable
} from "../../modules/utils";
import { DownloadViewReturn, refreshDmlToken } from "../../modules/api";
import {
  useLicencaService,
  LicencaPayload
} from "../../modules/business/licenca/licencaBusiness";
import {
  useGabaritoService,
  GabaritoProcessoOutputPayload,
  VeiculoConjuntoTransportadorGabaritoPayload,
  ImageConjuntoTransportadorGabaritoPayload
} from "../../modules/business/licenca/gabaritoBusiness";
import { useToast, useConfirm } from "../../modules/message";
import EntitySelectorCliente from "../cliente/EntitySelectorCliente.vue";
import { ClientePayload } from "../../modules/business/cliente/clienteBusiness";
import { EngenheiroPayload } from "../../modules/business/engenheiro/engenheiroBusiness";
import {
  TransportadorPayload,
  useTransportadorService
} from "../../modules/business/transportador/transportadorBusiness";
import {
  VeiculoTratorPayload,
  useVeiculoTratorService
} from "../../modules/business/veiculo/veiculoTratorBusiness";
import {
  CarretaPayload,
  useCarretaService
} from "../../modules/business/veiculo/carretaBusiness";
import { MenuModel } from "../../router";
import { useTipoCarroceriaService } from "../../modules/business/veiculo/carroceriaBusiness";
import EntitySelectorVeiculoTrator from "../veiculo/trator/EntitySelectorVeiculoTrator.vue";
import EntitySelectorCarreta from "../veiculo/carreta/EntitySelectorCarreta.vue";
import EntitySelectorMultiCarreta from "../veiculo/carreta/EntitySelectorMultiCarreta.vue";
import EntitySelectorEngenheiro from "../engenheiro/EntitySelectorEngenheiro.vue";
import EntitySelectorTransportador from "../transportador/EntitySelectorTransportador.vue";
import EntitySelectorGabarito from "./gabarito/EntitySelectorGabarito.vue";
import CrudLicencaOrgao from "./orgao/CrudLicencaOrgao.vue";
import HistoricoLicenca from "./historico/HistoricoLicenca.vue";

interface LicencaCadastroState {
  entity: LicencaPayload;
  stateReady: boolean;
  savedEntity: boolean;
  gabaritosLoaded: boolean;
  loadings: Array<Ref<boolean>>;
  gabaritosPermitidos: Array<GabaritoProcessoOutputPayload>;
  stateId: string;
  visualizacaoUrl: DownloadViewReturn | null;
  gabaritoUrl: DownloadViewReturn | null;
  maxVeiculos: number;
  widthImgGabarito: number | null;
  maxDistanciaEixoTandem: number;
  abaAtiva: number;
}

interface VeiculoDescriptorState {
  label?: string | null;
  subLabel?: string | null;
  full?: string | null;
  menu: Array<MenuModel>;
}

export default defineComponent({
  setup(props, { emit }) {
    const state = reactive<LicencaCadastroState>({
      entity: useLicencaService().safeLicenca(),
      savedEntity: false,
      stateReady: false,
      loadings: [],
      gabaritosPermitidos: [],
      gabaritosLoaded: false,
      stateId:
        "state-" +
        Math.random()
          .toString(36)
          .substring(2),
      visualizacaoUrl: null,
      gabaritoUrl: null,
      maxVeiculos: 4,
      maxDistanciaEixoTandem: 2.4,
      abaAtiva: 0,
      widthImgGabarito: null
    });

    const amIAllowed = (
      authority: string,
      permissionInfo?: PermissionPayload | string | null
    ) => {
      return useAuth().amIAllowed(authority, permissionInfo);
    };
    const amIBlocked = (
      authority: string,
      permissionInfo?: PermissionPayload | string | null
    ) => {
      return useAuth().amIBlocked(authority, permissionInfo);
    };

    const stateLoading = computed(() => {
      return state.loadings.length !== 0 || props.parentLoading;
    });

    const stateBlocked = computed(() => {
      return !!(
        stateLoading.value || !amIAllowed("edit", state.entity.permissionInfo)
      );
    });

    // com licença salva a aba 0 é a Visualização; sem ela, a única aba é a de cadastro
    const isAbaEdicao = computed(() =>
      state.entity.idLicenca ? state.abaAtiva === 1 : true
    );

    // Motivo vindo da API (licença já enviada ao órgão, robô cadastrando, arquivada...)
    const motivoBloqueioEdicao = computed(() =>
      state.entity.idLicenca
        ? amIBlocked("edit", state.entity.permissionInfo)?.info
        : undefined
    );

    const stateFullBlocked = computed(() => {
      return !!(
        stateBlocked.value ||
        (amIAllowed("view", "root-cliente") && !state.entity.cliente?.idCliente)
      );
    });

    const pesoSomadoEixos = computed(() => {
      let soma = 0;
      if (state.entity.conjuntoTransportador) {
        state.entity.conjuntoTransportador.forEach((veiculo) => {
          if (veiculo.conjuntosEixosVeiculo) {
            veiculo.conjuntosEixosVeiculo.forEach((conjuntoEixo) => {
              if (conjuntoEixo.pesoConjuntoEixos) {
                soma += Number(conjuntoEixo.pesoConjuntoEixos);
              }
            });
          }
        });
      }
      return round(2, soma);
    });

    // Taras (kg) da composição principal: cavalo e carretas. Rodízios não entram, como na carga
    // que os robôs enviam aos órgãos. null em "tara" = veículo escolhido sem tara cadastrada.
    const tarasComposicaoPrincipal = computed(() =>
      (state.entity.conjuntoTransportador || []).map((item) => {
        const veiculo = item.veiculoTrator
          ? item.veiculoTratorDaLicenca
          : item.carretaDaLicenca;
        return {
          selecionado: !!veiculo,
          tara:
            veiculo?.peso === null || veiculo?.peso === undefined
              ? null
              : Number(veiculo.peso)
        };
      })
    );

    // Carga líquida (t) = PBT - taras do cavalo e das carretas principais. Também sai no PDF.
    const cargaLiquida = computed((): number | null => {
      const taras = tarasComposicaoPrincipal.value;
      const pesoBrutoTotal = pesoSomadoEixos.value;
      if (
        pesoBrutoTotal === null ||
        !taras.length ||
        taras.some((t) => t.tara === null)
      ) {
        return null;
      }
      const somaTarasKg = taras.reduce(
        (soma, t) => soma + (t.tara as number),
        0
      );
      return round(2, pesoBrutoTotal - somaTarasKg / 1000);
    });

    const cargaLiquidaDescricao = computed(() => {
      const taras = tarasComposicaoPrincipal.value;
      if (!taras.length || taras.some((t) => !t.selecionado)) {
        return "";
      }
      return taras.some((t) => t.tara === null)
        ? "tara não informada"
        : "PBT - taras";
    });

    const totalAcopladas = computed(() => {
      return state.entity.conjuntoTransportador
        .map((c) =>
          c.carreta
            ? (c.rodiziosAssociadosDaLicenca
                ? c.rodiziosAssociadosDaLicenca.length
                : 0) + 1
            : 0
        )
        .reduce((tot, val) => tot + val, 0);
    });

    const possuiCarreta = computed(() => {
      return totalAcopladas.value > 0;
    });

    const balancoTraseiro = computed(() => {
      if (state.entity.conjuntoTransportador && state.entity.comprimentoTotal) {
        let total = state.entity.comprimentoTotal;
        if (state.entity.excessoDianteiro ?? 0) {
          total -= state.entity.excessoDianteiro ?? 0;
        }
        if (state.entity.excessoTraseiro ?? 0) {
          total -= state.entity.excessoTraseiro ?? 0;
        }
        state.entity.conjuntoTransportador.forEach((veiculo) => {
          if (veiculo.conjuntosEixosVeiculo) {
            veiculo.conjuntosEixosVeiculo.forEach((conjuntoEixo) => {
              if (conjuntoEixo.distanciaConjuntoEixoAnterior) {
                total -= conjuntoEixo.distanciaConjuntoEixoAnterior;
                if (conjuntoEixo.eixos) {
                  conjuntoEixo.eixos.forEach((eixo) => {
                    if (eixo.distanciaEixoAnterior) {
                      total -= eixo.distanciaEixoAnterior;
                    }
                  });
                }
              }
            });
          }
        });
        return round(2, total);
      } else {
        return 0;
      }
    });

    const balancoTraseiroMax = computed(() => {
      return 3.5;
    });

    const possuiVeiculoVazio = computed(() => {
      return (
        state.entity.conjuntoTransportador.filter(
          (v) =>
            (!v.veiculoTratorDaLicenca && !v.carretaDaLicenca) ||
            (v.veiculoTratorDaLicenca &&
              !v.veiculoTratorDaLicenca.idVeiculoTrator) ||
            (v.carretaDaLicenca && !v.carretaDaLicenca.idCarreta)
        ).length > 0
      );
    });

    const gabaritosFiltrados = computed(() => {
      if (
        amIAllowed("edit", state.entity.permissionInfo) &&
        !possuiVeiculoVazio.value
      ) {
        if (state.gabaritosPermitidos?.length) {
          const ret = useGabaritoService()
            .getGabaritosAtivos()
            .filter(
              (g) =>
                g.idGabarito &&
                state.gabaritosPermitidos
                  .map((gp) => gp.idGabarito)
                  .indexOf(g.idGabarito) >= 0
            );
          return ret;
        } else {
          return [];
        }
      } else {
        const gab = useGabaritoService().getGabarito(state.entity.idGabarito);
        return gab ? [gab] : [];
      }
    });

    const gabaritoSelecionado = computed(() => {
      return useGabaritoService().getGabarito(state.entity.idGabarito);
    });

    const gabaritoPermitidoSelecionado = computed(() => {
      const g = gabaritoSelecionado.value;
      if (state.gabaritosPermitidos && g) {
        return state.gabaritosPermitidos.filter(
          (gp) => gp.idGabarito == g.idGabarito
        )[0];
      }
      return null;
    });

    const composicaoEixos = computed(() => {
      if (state.entity.conjuntoTransportador) {
        return state.entity.conjuntoTransportador
          .map((v) => {
            if (gabaritoSelecionado.value) {
              const arrDisposicao = [];
              if (v.conjuntosEixosVeiculo?.length) {
                for (let c = 0; c < v.conjuntosEixosVeiculo.length; c++) {
                  const conjunto = v.conjuntosEixosVeiculo[c];

                  for (let e = 0; e < conjunto.eixos.length; e++) {
                    const eixo = conjunto.eixos[e];
                    const currDist =
                      (e == 0
                        ? conjunto.distanciaConjuntoEixoAnterior
                        : eixo.distanciaEixoAnterior) ?? 0;

                    if (
                      (c == 0 && e == 0) ||
                      currDist > state.maxDistanciaEixoTandem
                    ) {
                      arrDisposicao.push(0);
                    }
                    arrDisposicao[arrDisposicao.length - 1] += 1;
                  }
                }
              }

              if (v.veiculoTratorDaLicenca?.idVeiculoTrator) {
                v.disposicaoEixos = useVeiculoTratorService().getTracaoVeiculoTrator(
                  arrDisposicao,
                  v.veiculoTratorDaLicenca.tracao
                )?.disposicaoEixos;
              } else if (v.conjuntosEixosVeiculo?.length) {
                v.disposicaoEixos = useCarretaService().getDisposicaoEixosCarreta(
                  arrDisposicao
                )?.disposicaoEixos;
              }
            } else {
              v.disposicaoEixos = null;
              v.idTipoCarroceria = null;
            }

            return v.disposicaoEixos
              ? v.disposicaoEixos.map(String).join(",")
              : "";
          })
          .join("|");
      }

      return "";
    });

    const getTipoCarreta = (flTipoCarreta?: string | null) => {
      return useCarretaService().getTipoCarreta(flTipoCarreta);
    };

    const getTipoVeiculoTrator = (flTipoVeiculoTrator?: string | null) => {
      return useVeiculoTratorService().getTipoVeiculoTrator(
        flTipoVeiculoTrator
      );
    };

    const getTipoCarroceria = (idTipoCarroceria?: number | null) => {
      return useTipoCarroceriaService().getTipoCarroceria(idTipoCarroceria);
    };

    const clearGabaritoImagem = () => {
      if (state.gabaritoUrl) {
        state.gabaritoUrl.destroy();
        state.gabaritoUrl = null;
      }
    };

    const loadGabaritoImagem = () => {
      clearGabaritoImagem();
      if (state.entity.idGabarito) {
        const {
          downloadImagemGabaritosDosVeiculosExibicao
        } = useGabaritoService();
        // TODO KAIO IMPLEMENTAR REPROCESSADOR DE GABARITOS SE FOR DINAMICO
        downloadImagemGabaritosDosVeiculosExibicao(
          state.entity.idGabarito,
          state.entity.conjuntoTransportador
        ).then((ret) => {
          if (ret) {
            state.gabaritoUrl = ret;
          }
        });
      }
    };

    const processaGabaritosVeiculo = () => {
      if (
        state.entity.conjuntoTransportador.some(
          (v) =>
            !v.veiculoTratorDaLicenca?.idVeiculoTrator &&
            !v.carretaDaLicenca?.idCarreta
        )
      ) {
        state.gabaritosPermitidos = [];
        return Promise.resolve();
      }
      const { getGabaritosDosVeiculos, data, loading } = useGabaritoService();
      state.loadings.push(loading);

      return getGabaritosDosVeiculos(state.entity.conjuntoTransportador)
        .then(() => {
          state.gabaritosPermitidos = data.value ?? [];
          state.gabaritosLoaded = true;
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        })
        .catch(() => {
          state.gabaritosPermitidos = [];
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
    };

    const afterSetGabarito = (idGabarito?: number | null) => {
      state.entity.idGabarito = idGabarito ? idGabarito : undefined;
    };

    const onloadGabaritoImage = (evt: Event) => {
      state.widthImgGabarito =
        (evt.target as HTMLImageElement)?.naturalWidth ?? null;
    };

    const getPositionReferenteImagem = (
      positionImageStart?: ImageConjuntoTransportadorGabaritoPayload | null,
      positionImageEnd?: ImageConjuntoTransportadorGabaritoPayload | null
    ) => {
      if (!positionImageStart) {
        positionImageStart = positionImageEnd;
      }
      if (!positionImageEnd) {
        positionImageEnd = positionImageStart;
      }

      if (
        positionImageStart?.x &&
        positionImageEnd?.x &&
        state.widthImgGabarito
      ) {
        const xStart = positionImageStart?.x;
        const xEnd =
          (positionImageEnd?.x ? positionImageEnd.x : 0) +
          (positionImageEnd?.w ? positionImageEnd.w : 0);

        return (
          "left:" +
          (100 * ((xEnd - xStart) / 2 + xStart)) / state.widthImgGabarito +
          "%;" + //
          "transform: translate(-50%);height: 3rem; position: absolute;"
        );
      }
      return "";
    };

    const isChangeVeiculoTrator = (
      veiculoTratorComparacao: VeiculoTratorPayload,
      veiculoPosicao?: VeiculoTratorPayload | null
    ) => {
      return (
        veiculoPosicao &&
        (veiculoPosicao.flTipoVeiculoTrator !=
          veiculoTratorComparacao.flTipoVeiculoTrator ||
          veiculoPosicao.idTipoCarroceria !=
            veiculoTratorComparacao.idTipoCarroceria ||
          veiculoPosicao.numeroEixos != veiculoTratorComparacao.numeroEixos)
      );
    };

    const isChangeCarreta = (
      carretaComparacao: CarretaPayload,
      veiculoPosicao?: CarretaPayload | null
    ) => {
      return (
        veiculoPosicao &&
        (veiculoPosicao.flTipoCarreta != carretaComparacao.flTipoCarreta ||
          (
            getTipoCarroceria(veiculoPosicao.idTipoCarroceria)
              ?.carroceriasCompativeis ?? []
          ).indexOf(carretaComparacao.idTipoCarroceria ?? -1) < 0 ||
          veiculoPosicao.numeroEixos != carretaComparacao.numeroEixos)
      );
    };

    const setEntity = (entity: LicencaPayload) => {
      state.entity = useLicencaService().safeLicenca(entity);

      const docElement = document.querySelector(
        "#" + state.stateId + "_notaFiscalCarga"
      ) as HTMLInputElement;
      if (docElement) {
        docElement.value = "";
      }
    };

    const downloadNotaFiscalCarga = (newTab: boolean, onEnd: Function) => {
      if (!state.entity.idLicenca) {
        onEnd();
        return;
      }
      const { downloadNotaFiscalCarga, loading } = useLicencaService();
      state.loadings.push(loading);
      downloadNotaFiscalCarga(state.entity.idLicenca, newTab)
        .then(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
          onEnd();
        })
        .catch(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
          onEnd();
        });
    };

    const removeVeiculoConjunto = (
      item: VeiculoConjuntoTransportadorGabaritoPayload
    ) => {
      if (item) {
        const cbTrue = () => {
          state.entity.conjuntoTransportador.splice(
            state.entity.conjuntoTransportador.indexOf(item),
            1
          );
          processaGabaritosVeiculo();
        };
        if (
          !item.veiculoTratorDaLicenca?.idVeiculoTrator &&
          !item.carretaDaLicenca?.idCarreta
        ) {
          cbTrue();
        } else {
          useConfirm().require({
            message: item.veiculoTratorDaLicenca?.idVeiculoTrator
              ? "Deseja remover o veículo trator " +
                useVeiculoTratorService().getNomeVeiculoTrator(
                  item.veiculoTratorDaLicenca
                ) +
                "?"
              : item.carretaDaLicenca?.idCarreta
              ? "Deseja remover a carreta " +
                useCarretaService().getNomeCarreta(item.carretaDaLicenca) +
                ", bem como todos os rodízios desta posição?"
              : "Deseja remover o veículo",
            header: "Atenção",
            icon: "pi pi-info-circle",
            acceptClass: "p-button-danger",
            accept: () => {
              cbTrue();
            }
          });
        }
      }
    };

    const confirmSelectionTransportador = (t: TransportadorPayload) => {
      if (t) {
        state.entity.transportador = t;
      } else {
        state.entity.transportador = useLicencaService().safeLicenca().transportador;
      }
    };

    const confirmSelectionVeiculoTrator = (
      item: VeiculoConjuntoTransportadorGabaritoPayload,
      veiculoTrator?: VeiculoTratorPayload
    ) => {
      if (veiculoTrator && veiculoTrator.idVeiculoTrator) {
        if (isChangeVeiculoTrator(veiculoTrator, item.veiculoTratorDaLicenca)) {
          state.entity.idGabarito = null;
        }
        item.veiculoTratorDaLicenca = veiculoTrator;
        if (
          veiculoTrator.transportador?.idTransportador &&
          veiculoTrator.transportador.idTransportador !==
            state.entity.transportador?.idTransportador
        ) {
          const { getTransportador, data, loading } = useTransportadorService();
          getTransportador(veiculoTrator.transportador.idTransportador)
            .then(() => {
              confirmSelectionTransportador(data.value);
              state.loadings.splice(state.loadings.indexOf(loading), 1);
            })
            .catch(() => {
              state.loadings.splice(state.loadings.indexOf(loading), 1);
            });
        }
      } else {
        item.veiculoTratorDaLicenca = null;
      }
      processaGabaritosVeiculo();
    };

    const confirmSelectionCarreta = (
      item: VeiculoConjuntoTransportadorGabaritoPayload,
      carreta?: CarretaPayload
    ) => {
      if (carreta && carreta.idCarreta) {
        if (isChangeCarreta(carreta, item.carretaDaLicenca)) {
          state.entity.idGabarito = null;
        }
        item.carretaDaLicenca = carreta;
      } else {
        item.carretaDaLicenca = null;
      }
      processaGabaritosVeiculo();
    };

    const confirmSelectionRodizios = (
      item: VeiculoConjuntoTransportadorGabaritoPayload,
      carretas?: Array<CarretaPayload>
    ) => {
      if (carretas && carretas?.length > 0) {
        item.rodiziosAssociadosDaLicenca = carretas;
      } else {
        item.rodiziosAssociadosDaLicenca = [];
      }
    };

    const moveCarretaAntes = (
      item: VeiculoConjuntoTransportadorGabaritoPayload
    ) => {
      if (state.entity.conjuntoTransportador && item && item.nuSeqVeiculo) {
        if (
          item.nuSeqVeiculo < state.entity.conjuntoTransportador.length &&
          item.nuSeqVeiculo > 1
        ) {
          useConfirm().require({
            message: "Deseja mover o veículo para a proxima anterior?",
            header: "Atenção",
            icon: "pi pi-info-circle",
            accept: () => {
              const currIndex = state.entity.conjuntoTransportador.indexOf(
                item
              );
              const currNuSeqVeiculo = item.nuSeqVeiculo;
              const prevIndex = currIndex - 1;
              const prevItem = state.entity.conjuntoTransportador[prevIndex];
              state.entity.conjuntoTransportador.splice(currIndex, 1);
              state.entity.conjuntoTransportador.splice(prevIndex, 0, item);
              item.nuSeqVeiculo = prevItem.nuSeqVeiculo;
              prevItem.nuSeqVeiculo = currNuSeqVeiculo;
              state.entity.idGabarito = null;
              processaGabaritosVeiculo();
            }
          });
        }
      }
    };

    const moveCarretaDepois = (
      item: VeiculoConjuntoTransportadorGabaritoPayload
    ) => {
      if (state.entity.conjuntoTransportador && item && item.nuSeqVeiculo) {
        if (
          item.nuSeqVeiculo < state.entity.conjuntoTransportador.length - 1 &&
          item.nuSeqVeiculo > 0
        ) {
          useConfirm().require({
            message: "Deseja mover o veículo para a proxima posicao?",
            header: "Atenção",
            icon: "pi pi-info-circle",
            accept: () => {
              const currIndex = state.entity.conjuntoTransportador.indexOf(
                item
              );
              const currNuSeqVeiculo = item.nuSeqVeiculo;
              const nextIndex = currIndex + 1;
              const nextItem = state.entity.conjuntoTransportador[nextIndex];
              state.entity.conjuntoTransportador.splice(currIndex, 1);
              state.entity.conjuntoTransportador.splice(nextIndex, 0, item);
              item.nuSeqVeiculo = nextItem.nuSeqVeiculo;
              nextItem.nuSeqVeiculo = currNuSeqVeiculo;
              state.entity.idGabarito = null;
              processaGabaritosVeiculo();
            }
          });
        }
      }
    };

    const promoteRodizio = (
      item: VeiculoConjuntoTransportadorGabaritoPayload,
      rodizio?: CarretaPayload
    ) => {
      if (rodizio && rodizio.idCarreta && item) {
        useConfirm().require({
          message:
            "Deseja promover o rodízio " +
            useCarretaService().getNomeCarreta(rodizio) +
            " para a posicao Principal?",
          header: "Atenção",
          icon: "pi pi-info-circle",
          accept: () => {
            const carreta = copyObject(item.carretaDaLicenca, {});
            if (carreta) {
              item.carretaDaLicenca = copyObject(rodizio, {});
              if (item.rodiziosAssociadosDaLicenca) {
                const indexRodizio = item.rodiziosAssociadosDaLicenca.indexOf(
                  rodizio
                );
                if (indexRodizio > -1) {
                  item.rodiziosAssociadosDaLicenca.splice(
                    indexRodizio,
                    1,
                    carreta
                  );
                }
              } else {
                item.rodiziosAssociadosDaLicenca = [carreta];
              }
              processaGabaritosVeiculo();
            }
          }
        });
      }
    };

    const addVeiculoTrator = () => {
      state.entity.conjuntoTransportador.push({
        veiculoTrator: true,
        nuSeqVeiculo: state.entity.conjuntoTransportador.length,
        conjuntosEixosVeiculo: []
      });
    };

    const addCarreta = () => {
      state.entity.conjuntoTransportador.push({
        carreta: true,
        nuSeqVeiculo: state.entity.conjuntoTransportador.length,
        conjuntosEixosVeiculo: []
      });
    };

    const processVeiculosVisuals = (
      veiculo: VeiculoConjuntoTransportadorGabaritoPayload
    ) => {
      const ret = {
        label: "",
        subLabel: "",
        full: "",
        menu: []
      } as VeiculoDescriptorState;

      let tipo = "" as string | null | undefined;
      let carroceria = "" as string | null | undefined;
      let eixos = 0 as number | null | undefined;

      if (veiculo.veiculoTrator) {
        const t = getTipoVeiculoTrator(
          veiculo.veiculoTratorDaLicenca?.flTipoVeiculoTrator
        );
        tipo = t?.descricao;
        if (t?.idsCarroceriasAceitas?.length) {
          carroceria = getTipoCarroceria(
            veiculo.veiculoTratorDaLicenca?.idTipoCarroceria
          )?.descricao;
        }
        eixos = veiculo.veiculoTratorDaLicenca?.numeroEixos;
      } else if (veiculo.carreta) {
        const t = getTipoCarreta(veiculo.carretaDaLicenca?.flTipoCarreta);
        tipo = t?.descricao;
        if (t?.idsCarroceriasAceitas?.length) {
          carroceria = getTipoCarroceria(
            veiculo.carretaDaLicenca?.idTipoCarroceria
          )?.descricao;
        }
        eixos = veiculo.carretaDaLicenca?.numeroEixos;
        const nuSeqVeiculo = veiculo.nuSeqVeiculo ?? 0;
        if (state.entity.conjuntoTransportador.length > 2 && nuSeqVeiculo > 1) {
          ret.menu.push({
            label: "Mover para Antes",
            icon: "fa-solid fa-arrow-left",
            command: () => {
              moveCarretaAntes(veiculo);
            }
          });
        }
        if (
          state.entity.conjuntoTransportador.length > 2 &&
          nuSeqVeiculo < state.entity.conjuntoTransportador.length - 1 &&
          nuSeqVeiculo > 0
        ) {
          ret.menu.push({
            label: "Mover para Depois",
            icon: "fa-solid fa-arrow-right",
            command: () => {
              moveCarretaDepois(veiculo);
            }
          });
        }
      }

      if (tipo) {
        ret.label += tipo;
        ret.full += tipo;
      }

      if (carroceria) {
        if (carroceria == tipo) {
          ret.full += ret.full ? ", " : "";
        } else {
          ret.subLabel += carroceria;
          ret.full += (ret.full ? ", " : "") + carroceria;
        }
      }

      if (eixos) {
        ret.subLabel +=
          (ret.subLabel ? " " : "") + eixos + (eixos > 1 ? " eixos" : " eixo");
        ret.full +=
          (ret.full ? " " : "") + eixos + (eixos > 1 ? " eixos" : " eixo");
      }

      return ret;
    };

    const veiculosVisuals = computed(() => {
      return state.entity.conjuntoTransportador.map((v) =>
        processVeiculosVisuals(v)
      );
    });

    const buscaTipoCarroceriaValido = (nuSeqVeiculoIgnorado: number) => {
      return state.entity.conjuntoTransportador
        .filter((v) => v.nuSeqVeiculo !== nuSeqVeiculoIgnorado)
        .map(
          (v) =>
            v.idTipoCarroceria ||
            (v.veiculoTratorDaLicenca &&
              getTipoVeiculoTrator(v.veiculoTratorDaLicenca.flTipoVeiculoTrator)
                ?.unidadeComCarga &&
              v.veiculoTratorDaLicenca.idTipoCarroceria) ||
            (v.carretaDaLicenca &&
              getTipoCarreta(v.carretaDaLicenca.flTipoCarreta)
                ?.unidadeComCarga &&
              v.carretaDaLicenca.idTipoCarroceria) ||
            null
        )
        .map((id) => getTipoCarroceria(id))
        .filter((tp) => !tp?.auxiliar)
        .find((tp) => !!tp);
    };

    const possuiCarga = computed(() => {
      return !!buscaTipoCarroceriaValido(
        state.entity.conjuntoTransportador.length
      );
    });

    const blockedSelectionVeiculoTrator = (
      veiculoTrator: VeiculoTratorPayload,
      nuSeq: number
    ) => {
      if (!veiculoTrator) {
        return "Veiculo inválido";
      }
      const veiculoPosicao = state.entity.conjuntoTransportador.find(
        (v) => v.nuSeqVeiculo == nuSeq
      ) as VeiculoConjuntoTransportadorGabaritoPayload;
      if (
        veiculoPosicao.idTipoCarroceria &&
        veiculoTrator.idTipoCarroceria != veiculoPosicao.idTipoCarroceria
      ) {
        return (
          "O gabarito exige a carroceria do tipo " +
          getTipoCarroceria(
            veiculoPosicao.idTipoCarroceria
          )?.descricao?.toUpperCase()
        );
      }
      if (
        getTipoVeiculoTrator(veiculoTrator.flTipoVeiculoTrator)?.unidadeComCarga
      ) {
        const tipoCarroceriaOutrasPosicoes = buscaTipoCarroceriaValido(nuSeq);
        if (
          tipoCarroceriaOutrasPosicoes &&
          !getTipoCarroceria(veiculoTrator.idTipoCarroceria)?.auxiliar &&
          !(
            tipoCarroceriaOutrasPosicoes?.idTipoCarroceria ==
              veiculoTrator.idTipoCarroceria ||
            (
              tipoCarroceriaOutrasPosicoes?.carroceriasCompativeis ?? []
            ).indexOf(veiculoTrator.idTipoCarroceria ?? -1) >= 0
          )
        ) {
          return (
            "A carroceria deve estar entre os tipos " +
            ((tipoCarroceriaOutrasPosicoes?.carroceriasCompativeis ?? [])
              .map((id) => getTipoCarroceria(id)?.descricao?.toUpperCase())
              .join(",") ?? "VAZIO")
          );
        }
      }

      return false;
    };

    const blockedSelectionCarreta = (
      carreta: CarretaPayload,
      nuSeq: number
    ) => {
      if (!carreta) {
        return "Veiculo inválido";
      }

      const veiculoJaPresente = state.entity.conjuntoTransportador.find(
        (v) =>
          (v.nuSeqVeiculo != nuSeq &&
            v.carretaDaLicenca?.idCarreta == carreta.idCarreta) ||
          (v.rodiziosAssociadosDaLicenca &&
            v.rodiziosAssociadosDaLicenca.find(
              (r) => r.idCarreta == carreta.idCarreta
            ))
      );
      if (veiculoJaPresente) {
        return (
          "Carreta já selecionada na posição " +
          veiculoJaPresente.nuSeqVeiculo +
          (veiculoJaPresente.carretaDaLicenca?.idCarreta == carreta.idCarreta
            ? "."
            : " como um rodízio.")
        );
      }
      if (getTipoCarreta(carreta.flTipoCarreta)?.unidadeComCarga) {
        const tipoCarroceriaOutrasPosicoes = buscaTipoCarroceriaValido(nuSeq);
        if (
          tipoCarroceriaOutrasPosicoes &&
          !getTipoCarroceria(carreta.idTipoCarroceria)?.auxiliar &&
          !(
            tipoCarroceriaOutrasPosicoes?.idTipoCarroceria ==
              carreta.idTipoCarroceria ||
            (
              tipoCarroceriaOutrasPosicoes?.carroceriasCompativeis ?? []
            ).indexOf(carreta.idTipoCarroceria ?? -1) >= 0
          )
        ) {
          return (
            "A carroceria estar entre os tipos " +
            ((tipoCarroceriaOutrasPosicoes?.carroceriasCompativeis ?? [])
              .map((id) => getTipoCarroceria(id)?.descricao?.toUpperCase())
              .join(", ") ?? "VAZIO")
          );
        }
      }
      return false;
    };

    const blockedSelectionRodizio = (
      rodizio: CarretaPayload,
      nuSeq: number
    ) => {
      if (rodizio) {
        const veiculoJaPresente = state.entity.conjuntoTransportador.find(
          (v) =>
            v.carretaDaLicenca?.idCarreta == rodizio.idCarreta ||
            (v.nuSeqVeiculo != nuSeq &&
              v.rodiziosAssociadosDaLicenca &&
              v.rodiziosAssociadosDaLicenca.find(
                (r) => r.idCarreta == rodizio.idCarreta
              ))
        );

        if (veiculoJaPresente) {
          return (
            "Carreta já selecionada na posição " +
            veiculoJaPresente.nuSeqVeiculo +
            (veiculoJaPresente.carretaDaLicenca?.idCarreta == rodizio.idCarreta
              ? "."
              : " como um Rodízio.")
          );
        }

        const veiculoPosicao = state.entity.conjuntoTransportador
          .filter((v) => v.nuSeqVeiculo == nuSeq && v.carretaDaLicenca)
          .map((v) => v.carretaDaLicenca)
          .find((c) => !!c) as CarretaPayload;

        if (isChangeCarreta(rodizio, veiculoPosicao)) {
          return (
            "Para ser um rodízio da posição " +
            nuSeq +
            ", O veículo precisa ser do tipo " +
            getTipoCarreta(
              veiculoPosicao.flTipoCarreta
            )?.descricao?.toUpperCase() +
            ", com carroceria entre os tipos " +
            ((
              getTipoCarroceria(veiculoPosicao.idTipoCarroceria)
                ?.carroceriasCompativeis ?? []
            )
              .map((id) => getTipoCarroceria(id)?.descricao?.toUpperCase())
              .join(", ") ?? "VAZIO") +
            ", e ter " +
            veiculoPosicao.numeroEixos +
            " eixos."
          );
        }
      }

      return false;
    };

    const downloadVisualizacao = (newTab?: boolean) => {
      if (!state.entity.idLicenca) {
        return;
      }
      const { downloadVisualizacao, loading } = useLicencaService();
      state.loadings.push(loading);
      downloadVisualizacao(state.entity.idLicenca, newTab)
        .then(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        })
        .catch(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
    };

    const closeScreen = () => {
      emit(
        "after-register-screen-closed",
        state.savedEntity ? state.entity : undefined
      );
    };

    const confirmSelectionCliente = (c: ClientePayload) => {
      if (c) {
        state.entity.cliente = c;
      }
    };

    const confirmSelectionEngenheiro = (eng: EngenheiroPayload) => {
      if (eng) {
        state.entity.engenheiro = eng;
      } else {
        state.entity.engenheiro = useLicencaService().safeLicenca().engenheiro;
      }
    };

    const clearVisualizacao = () => {
      if (state.visualizacaoUrl) {
        state.visualizacaoUrl.destroy();
        state.visualizacaoUrl = null;
      }
    };

    const loadVisualizacao = () => {
      if (state.entity.idLicenca) {
        clearVisualizacao();
        const { downloadVisualizacaoExibicao } = useLicencaService();
        downloadVisualizacaoExibicao(state.entity.idLicenca).then((ret) => {
          if (ret) {
            state.visualizacaoUrl = ret;
          }
        });
      }
    };

    watch([refreshDmlToken], () => {
      const token = state.visualizacaoUrl?.url;
      waitUntilStable(
        refreshDmlToken.value,
        () => {
          return refreshDmlToken.value;
        },
        () => {
          const currToken = state.visualizacaoUrl?.url;
          if (token == currToken) {
            loadVisualizacao();
          }
        },
        500
      );
    });

    const deleteTempFiles = () => {
      if (
        state.entity.notaFiscalCarga &&
        state.entity.notaFiscalCarga.keyBlDocumentoTemp
      ) {
        useStorage().deleteTempFile(
          state.entity.notaFiscalCarga.keyBlDocumentoTemp
        );
        state.entity.notaFiscalCarga.keyBlDocumentoTemp = null;
      }
    };

    const save = () => {
      if (props.previewMode) {
        state.savedEntity = true;
        useToast().success(
          "Alterações aplicadas — não esqueça de aceitar a etapa"
        );
        emit("save-preview", JSON.parse(JSON.stringify(state.entity)));
        closeScreen();
        return;
      }
      const idLicencaProps = props.idLicenca ?? 0;
      const isInsert = !idLicencaProps;
      const {
        saveNewLicenca,
        updateLicenca,
        loading: loadingCadastro,
        data: dataCadastro
      } = useLicencaService();
      state.loadings.push(loadingCadastro);
      (isInsert
        ? saveNewLicenca(state.entity)
        : updateLicenca(idLicencaProps, state.entity)
      )
        .then(() => {
          state.loadings.splice(state.loadings.indexOf(loadingCadastro), 1);
          setEntity(dataCadastro.value);
          state.savedEntity = true;
          useToast().success("Licença salva com sucesso");
          if (isInsert) {
            emit("after-save-new-entity", dataCadastro.value.idLicenca);
          }
        })
        .catch(() => {
          deleteTempFiles();
          state.loadings.splice(state.loadings.indexOf(loadingCadastro), 1);
        });
    };

    const gerarCopia = () => {
      emit("generate-copy", state.entity.idLicenca);
    };

    const processFile = (fileElementId: string) => {
      return new Promise<string>((resolve) => {
        const file = document.querySelector(
          "#" + fileElementId
        ) as HTMLInputElement;
        if (!file || !file.files || file.files.length === 0) {
          resolve("");
        } else {
          const formData = new FormData();
          formData.append("file", file.files[0]);
          const storage = useStorage();
          state.loadings.push(storage.loading);
          storage
            .uploadTempFile(formData)
            .then((key: string) => {
              state.loadings.splice(state.loadings.indexOf(storage.loading), 1);
              resolve(key);
            })
            .catch(() => {
              state.loadings.splice(state.loadings.indexOf(storage.loading), 1);
            });
        }
      });
    };

    const pesoSomadoEixosToast = () => {
      if (
        (pesoSomadoEixos.value ?? 0) < (gabaritoSelecionado.value?.peso ?? 0)
      ) {
        useToast().warning(
          "O valor do PBTC está com " +
            pesoSomadoEixos.value +
            "t o máximo permitido para o conjunto é " +
            gabaritoSelecionado.value?.peso +
            "t"
        );
      }
    };

    watch(pesoSomadoEixos, () => {
      pesoSomadoEixosToast();
    });

    const submitSave = () => {
      // licença bloqueada para o usuário (ver motivoBloqueioEdicao): a API também recusa
      if (stateFullBlocked.value) {
        return;
      }
      pesoSomadoEixosToast();
      const arrayPromises = new Array<Promise<string>>();
      arrayPromises.push(
        processFile(state.stateId + "_notaFiscalCarga").then((key) => {
          state.entity.notaFiscalCarga = state.entity.notaFiscalCarga ?? {};
          return (state.entity.notaFiscalCarga.keyBlDocumentoTemp = key);
        })
      );

      Promise.all(arrayPromises).then(
        () => {
          save();
        },
        () => {
          deleteTempFiles();
        }
      );
    };

    onMounted(async () => {
      const {
        getLicenca,
        newLicenca,
        copyLicenca,
        data,
        loading
      } = useLicencaService();
      state.loadings.push(loading);
      if (props.cliente) {
        state.entity.cliente = props.cliente;
      }

      if (props.previewMode && props.previewInitialEntity) {
        setEntity(JSON.parse(JSON.stringify(props.previewInitialEntity)));
        state.loadings.splice(state.loadings.indexOf(loading), 1);
        state.stateReady = true;
        processaGabaritosVeiculo();
        return;
      }

      (props.idLicencaCopy
        ? copyLicenca(props.idLicencaCopy)
        : props.idLicenca
        ? getLicenca(props.idLicenca)
        : newLicenca(props.cliente?.idCliente)
      )
        .then(() => {
          setEntity(data.value);
          state.loadings.splice(state.loadings.indexOf(loading), 1);
          state.stateReady = true;

          if (props.idLicenca) {
            loadVisualizacao();
          }

          processaGabaritosVeiculo().then(() => {
            if (
              !state.entity.idLicenca &&
              state.entity.conjuntoTransportador?.length == 0
            ) {
              addVeiculoTrator();
            }
          });
        })
        .catch(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
          closeScreen();
        });
    });

    onUnmounted(async () => {
      clearVisualizacao();
      clearGabaritoImagem();
    });

    watch([gabaritosFiltrados], () => {
      if (state.gabaritosLoaded) {
        let idGabarito = state.entity.idGabarito;
        if (state.gabaritosPermitidos.length == 1) {
          idGabarito = state.gabaritosPermitidos[0].idGabarito;
        } else if (
          idGabarito &&
          state.gabaritosPermitidos
            .map((gp) => gp.idGabarito)
            .indexOf(idGabarito) < 0
        ) {
          idGabarito = null;
        }

        if (idGabarito != state.entity.idGabarito) {
          state.entity.idGabarito = idGabarito;
        }
      }
    });

    watch([composicaoEixos], () => {
      if (!possuiVeiculoVazio.value) {
        processaGabaritosVeiculo();
      }
    });

    watch([gabaritoPermitidoSelecionado, gabaritoSelecionado], () => {
      const gp = gabaritoPermitidoSelecionado.value;
      const gs = gabaritoSelecionado.value;
      if (gp && gs && gp.idGabarito == gs.idGabarito) {
        loadGabaritoImagem();
        const conjunto = gp.conjuntoTransportador ?? gs.conjuntoTransportador;
        if (conjunto && conjunto.length) {
          const conjuntoAplicado: Array<VeiculoConjuntoTransportadorGabaritoPayload> = JSON.parse(
            JSON.stringify(conjunto)
          );
          let tipoCargaCarrocerias;
          for (let i = 0; i < conjuntoAplicado.length; i++) {
            const veiculoConjunto = conjuntoAplicado[i];
            const veiculoLicenca = state.entity.conjuntoTransportador[i];
            if (!veiculoLicenca.conjuntosEixosVeiculo) {
              veiculoLicenca.conjuntosEixosVeiculo = [];
            }
            copyObject(clearObject(veiculoConjunto), veiculoLicenca, [
              "veiculoTratorDaLicenca",
              "carretaDaLicenca",
              "rodiziosAssociadosDaLicenca",
              "conjuntosEixosVeiculo"
            ]);
            if (!tipoCargaCarrocerias && veiculoLicenca) {
              tipoCargaCarrocerias = getTipoCarroceria(
                veiculoLicenca.veiculoTratorDaLicenca?.idTipoCarroceria ||
                  veiculoLicenca.carretaDaLicenca?.idTipoCarroceria
              )?.tipoCargaPadrao;
            }

            ///////////////////
            const totalEixos = veiculoConjunto.conjuntosEixosVeiculo
              .map((el) => el.eixos.length)
              .reduce((tot, val) => tot + val, 0);

            let conjuntoAtual = null;
            const conjuntosVeiculo = [];
            let indiceConjuntoAtualConjunto = 0;
            let indiceConjuntoAtualLicenca = 0;
            let indiceEixoConjuntoAtualConjunto = 0;
            let indiceEixoConjuntoAtualLicenca = 0;

            for (let j = 0; j < totalEixos; j++) {
              let conjuntoEixoVeiculoConjunto =
                veiculoConjunto.conjuntosEixosVeiculo[
                  indiceConjuntoAtualConjunto
                ];

              if (
                indiceEixoConjuntoAtualConjunto >=
                conjuntoEixoVeiculoConjunto.eixos.length
              ) {
                indiceConjuntoAtualConjunto++;
                conjuntoEixoVeiculoConjunto =
                  veiculoConjunto.conjuntosEixosVeiculo[
                    indiceConjuntoAtualConjunto
                  ];
                indiceEixoConjuntoAtualConjunto = 0;
                conjuntoAtual = null;
              }

              let conjuntoEixoVeiculoLicenca =
                veiculoLicenca.conjuntosEixosVeiculo[
                  indiceConjuntoAtualLicenca
                ];
              if (conjuntoEixoVeiculoLicenca) {
                if (
                  indiceEixoConjuntoAtualLicenca >=
                  conjuntoEixoVeiculoLicenca.eixos.length
                ) {
                  indiceConjuntoAtualLicenca++;
                  conjuntoEixoVeiculoLicenca =
                    veiculoLicenca.conjuntosEixosVeiculo[
                      indiceConjuntoAtualLicenca
                    ];
                  indiceEixoConjuntoAtualLicenca = 0;
                }
              }

              if (conjuntoAtual == null) {
                conjuntoAtual = copyObject(
                  clearObject(cloneObject(conjuntoEixoVeiculoConjunto)),
                  {},
                  ["eixos", "distanciaConjuntoEixoAnterior"]
                );
                conjuntoAtual.eixos = [];
                conjuntosVeiculo.push(conjuntoAtual);

                if (
                  conjuntoEixoVeiculoLicenca &&
                  conjuntoEixoVeiculoLicenca.pesoConjuntoEixos
                ) {
                  const pesoMaximoConjunto =
                    conjuntoAtual.pesoMaximoConjuntoEixos ?? 50;
                  const pesoAtualConjuntoLicenca =
                    conjuntoEixoVeiculoLicenca.pesoConjuntoEixos ?? 0;
                  if (pesoMaximoConjunto < pesoAtualConjuntoLicenca) {
                    conjuntoAtual.pesoConjuntoEixos =
                      conjuntoAtual.pesoRecomendadoConjuntoEixos;
                  } else if (pesoAtualConjuntoLicenca) {
                    conjuntoAtual.pesoConjuntoEixos = pesoAtualConjuntoLicenca;
                  }
                } else {
                  conjuntoAtual.pesoConjuntoEixos =
                    conjuntoAtual.pesoRecomendadoConjuntoEixos;
                }

                if (!conjuntoAtual.pesoConjuntoEixos) {
                  conjuntoAtual.pesoConjuntoEixos =
                    conjuntoAtual.pesoRecomendadoConjuntoEixos;
                }
              }

              const currEixo = clearObject(
                cloneObject(
                  conjuntoEixoVeiculoConjunto.eixos[
                    indiceEixoConjuntoAtualConjunto
                  ]
                )
              );

              const currEixoLicenca = conjuntoEixoVeiculoLicenca
                ? conjuntoEixoVeiculoLicenca.eixos[
                    indiceEixoConjuntoAtualLicenca
                  ]
                : null;
              if (currEixoLicenca) {
                if (indiceEixoConjuntoAtualConjunto == 0) {
                  if (indiceEixoConjuntoAtualLicenca > 0) {
                    conjuntoAtual.distanciaConjuntoEixoAnterior =
                      currEixoLicenca.distanciaEixoAnterior;
                  } else {
                    conjuntoAtual.distanciaConjuntoEixoAnterior =
                      conjuntoEixoVeiculoLicenca.distanciaConjuntoEixoAnterior;
                  }
                } else if (indiceEixoConjuntoAtualLicenca == 0) {
                  currEixo.distanciaEixoAnterior =
                    conjuntoEixoVeiculoLicenca.distanciaConjuntoEixoAnterior;
                } else {
                  currEixo.distanciaEixoAnterior =
                    currEixoLicenca.distanciaEixoAnterior;
                }

                if (currEixoLicenca.rodas) {
                  currEixo.rodas = currEixoLicenca.rodas;
                }
              }
              conjuntoAtual.eixos.push(currEixo);

              indiceEixoConjuntoAtualConjunto++;
              indiceEixoConjuntoAtualLicenca++;
            }

            veiculoLicenca.conjuntosEixosVeiculo = conjuntosVeiculo;

            /////////////
            /*
            for (
              let j = 0;
              j < veiculoConjunto.conjuntosEixosVeiculo.length;
              j++
            ) {
              const conjuntoEixoVeiculoConjunto =
                veiculoConjunto.conjuntosEixosVeiculo[j];
              if (veiculoLicenca.conjuntosEixosVeiculo.length <= j) {
                veiculoLicenca.conjuntosEixosVeiculo.push({ eixos: [] });
              }
              const conjuntoEixoVeiculoLicenca =
                veiculoLicenca.conjuntosEixosVeiculo[j];
              copyObject(
                clearObject(conjuntoEixoVeiculoConjunto),
                conjuntoEixoVeiculoLicenca,
                ["eixos"]
              );
              if (!conjuntoEixoVeiculoLicenca.pesoConjuntoEixos) {
                conjuntoEixoVeiculoLicenca.pesoConjuntoEixos =
                  conjuntoEixoVeiculoConjunto.pesoRecomendadoConjuntoEixos;
              }
              for (
                let k = 0;
                k < conjuntoEixoVeiculoConjunto.eixos.length;
                k++
              ) {
                const eixoConjunto = conjuntoEixoVeiculoConjunto.eixos[k];
                if (conjuntoEixoVeiculoLicenca.eixos.length <= k) {
                  conjuntoEixoVeiculoLicenca.eixos.push({});
                }
                const eixoLicenca = conjuntoEixoVeiculoLicenca.eixos[k];
                copyObject(clearObject(eixoConjunto), eixoLicenca, ["rodas"]);
                if (!eixoLicenca.rodas) {
                  eixoLicenca.rodas = eixoConjunto.rodas;
                }
              }
              if (
                conjuntoEixoVeiculoConjunto.eixos.length <
                conjuntoEixoVeiculoLicenca.eixos.length
              ) {
                const diff =
                  conjuntoEixoVeiculoLicenca.eixos.length -
                  conjuntoEixoVeiculoConjunto.eixos.length;
                conjuntoEixoVeiculoLicenca.eixos.splice(diff * -1, diff);
              }
            }



            if (
              veiculoConjunto.conjuntosEixosVeiculo.length <
              veiculoLicenca.conjuntosEixosVeiculo.length
            ) {
              const diff =
                veiculoLicenca.conjuntosEixosVeiculo.length -
                veiculoConjunto.conjuntosEixosVeiculo.length;
              veiculoLicenca.conjuntosEixosVeiculo.splice(diff * -1, diff);
            }
            */
            ///////////////////
          }
          if (
            conjuntoAplicado.length < state.entity.conjuntoTransportador.length
          ) {
            const diff =
              state.entity.conjuntoTransportador.length -
              conjuntoAplicado.length;
            state.entity.conjuntoTransportador.splice(diff * -1, diff);
          }
          const tiposPadrao = useGabaritoService()
            .getGabaritosAtivos()
            .map((g) => g.tipoCarga)
            .filter((e) => !!e);
          if (tipoCargaCarrocerias) {
            tiposPadrao.push(tipoCargaCarrocerias);
          }
          if (
            !state.entity.tipoCarga ||
            tiposPadrao.indexOf(state.entity.tipoCarga) >= 0
          ) {
            state.entity.tipoCarga = tipoCargaCarrocerias
              ? tipoCargaCarrocerias
              : gs.tipoCarga;
          }
        }
      }
    });

    return {
      submitSave,
      gerarCopia,
      closeScreen,
      amIAllowed,
      amIBlocked,
      isAbaEdicao,
      formatNumber,
      confirmSelectionCliente,
      stateLoading,
      stateBlocked,
      stateFullBlocked,
      motivoBloqueioEdicao,
      composicaoEixos,
      addVeiculoTrator,
      addCarreta,
      removeVeiculoConjunto,
      blockedSelectionVeiculoTrator,
      blockedSelectionCarreta,
      blockedSelectionRodizio,
      confirmSelectionVeiculoTrator,
      confirmSelectionCarreta,
      confirmSelectionEngenheiro,
      confirmSelectionTransportador,
      confirmSelectionRodizios,
      getTipoVeiculoTrator,
      getTipoCarreta,
      getTipoCarroceria,
      downloadNotaFiscalCarga,
      promoteRodizio,
      moveCarretaAntes,
      moveCarretaDepois,
      downloadVisualizacao,
      gabaritosFiltrados,
      gabaritoSelecionado,
      gabaritoPermitidoSelecionado,
      afterSetGabarito,
      possuiVeiculoVazio,
      pesoSomadoEixos,
      cargaLiquida,
      cargaLiquidaDescricao,
      possuiCarreta,
      possuiCarga,
      totalAcopladas,
      veiculosVisuals,
      balancoTraseiro,
      balancoTraseiroMax,
      onloadGabaritoImage,
      getPositionReferenteImagem,
      pesoSomadoEixosToast,
      ...toRefs(state)
    };
  },
  components: {
    EntitySelectorCliente,
    EntitySelectorCarreta,
    EntitySelectorMultiCarreta,
    EntitySelectorVeiculoTrator,
    EntitySelectorEngenheiro,
    EntitySelectorTransportador,
    EntitySelectorGabarito,
    CrudLicencaOrgao,
    HistoricoLicenca
  },
  props: {
    idLicenca: Number,
    idLicencaCopy: Number,
    cliente: Object as PropType<ClientePayload>,
    parentLoading: Boolean,
    previewMode: Boolean,
    previewInitialEntity: Object as PropType<LicencaPayload>
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
// Título e corpo mais próximos só neste diálogo. O Dialog é renderizado fora da árvore do
// componente (teleport), então o estilo com escopo não alcança o cabeçalho nem o conteúdo dele;
// e o main.scss define esses respiros com !important.
.p-dialog.dialog-internal:has(.cadastro-licenca-titulo) {
  .p-dialog-header {
    padding-top: $space-3 !important;
    padding-bottom: $space-3 !important;
  }

  .p-dialog-content {
    padding-top: $space-3 !important;
  }

  // botoes do rodape fixo (Salvar, Gerar Copia) alinhados a esquerda
  .p-dialog-footer {
    text-align: left;
  }

  // mesmo padrao das barras de acoes (SearchResult acoesFixas): retangulares e separados
  .licenca-rodape-acoes {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;

    .p-button {
      margin: 0 !important;
    }
  }
}
</style>

<style scoped lang="scss">
.cadastro-licenca-titulo {
  margin: 0;
}

.licenca-bloqueio-aviso {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin: 0 0 0.5rem;
  padding: 0.625rem 0.875rem;
  border-left: 4px solid $warning;
  border-radius: 4px;
  background: $warning-bg;
  font-size: 0.95rem;
  line-height: 1.4;

  .pi {
    color: $warning;
    margin-top: 0.15rem;
  }
}
</style>
